// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistics {
  max-width: 960px;
  margin: 0 auto;
  padding: 4px 4px 32px;
  color: var(--vb-text);
  box-sizing: border-box;
}

.stats-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.stats-toolbar-left {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.statistics h1 {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-align: left;
  text-transform: none;
}

.stats-range {
  font-size: 12px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.range-chips {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.chip {
  min-height: 32px;
  padding: 4px 10px;
  border: 1px solid var(--vb-border);
  border-radius: 999px;
  background: var(--vb-surface);
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.chip.active {
  background: var(--vb-navy);
  border-color: transparent;
  color: #fff;
}

body.night-mode .chip.active {
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
}

.custom-range {
  margin-bottom: 10px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  padding: 0 12px;
}

.custom-range summary {
  cursor: pointer;
  list-style: none;
  padding: 8px 0;
  font-size: 12px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.custom-range summary::-webkit-details-marker { display: none; }

.custom-range-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding-bottom: 10px;
}

.custom-range-fields label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.custom-range-fields input {
  min-height: 40px;
  padding: 6px 8px;
  border: 1px solid var(--vb-border);
  border-radius: 8px;
  background: var(--vb-surface-2);
  color: var(--vb-text);
  font-size: 14px;
}

.stats-tabs {
  display: flex;
  gap: 0;
  margin: 0 0 14px;
  border-bottom: 1px solid var(--vb-border);
}

.stats-tabs button {
  flex: 1 1;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 8px 6px 10px;
  margin-bottom: -1px;
  color: var(--vb-text-muted);
  font-size: 13px;
  font-weight: 650;
  cursor: pointer;
}

.stats-tabs button.active {
  color: var(--vb-text);
  border-bottom-color: var(--vb-primary);
}

.record-card,
.form-strip,
.metric-strip,
.list-section {
  margin-bottom: 12px;
}

.record-card {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 14px;
  padding: 14px 14px 12px;
}

.record-line {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}

.record-num {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 2.2em;
}

.record-num strong {
  font-family: var(--vb-font-score);
  font-size: 2.4rem;
  font-weight: 800;
  line-height: 0.9;
}

.record-num span,
.record-pct span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--vb-text-muted);
}

.record-sep {
  color: var(--vb-text-muted);
  font-weight: 700;
  padding-bottom: 14px;
}

.record-pct {
  margin-left: auto;
  text-align: right;
}

.record-pct strong {
  display: block;
  font-family: var(--vb-font-score);
  font-size: 1.8rem;
  font-weight: 800;
  line-height: 1;
}

.record-bar {
  display: flex;
  height: 6px;
  margin-top: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--vb-surface-2);
}

.record-bar .seg.win { background: var(--vb-success); }
.record-bar .seg.loss { background: var(--vb-danger); }
.record-bar .seg.tie { background: var(--vb-warning); }

.form-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.form-label {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--vb-text-muted);
  flex-shrink: 0;
}

.form-display {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  min-width: 0;
}

.form-dot {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: grid;
  place-items: center;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
}

.form-win { background: var(--vb-success); }
.form-loss { background: var(--vb-danger); }
.form-tie { background: var(--vb-warning); color: #0f172a; }

.metric-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.metric-strip div {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 10px 8px;
  text-align: center;
  min-width: 0;
}

.metric-strip strong {
  display: block;
  font-size: 15px;
  font-weight: 800;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metric-strip span {
  font-size: 10px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.list-section h2 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 800;
  text-align: left;
  text-transform: none;
  color: var(--vb-text-muted);
}

.stats-search {
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  margin-bottom: 10px;
  padding: 8px 12px;
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 14px;
}

.rank-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.stat-row {
  display: block;
  width: 100%;
  text-align: left;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 10px 12px;
  color: inherit;
  cursor: default;
}

.stat-row.is-clickable { cursor: pointer; }
.stat-row.is-clickable:hover { background: var(--vb-surface-hover); }

.stat-row-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 8px;
}

.stat-row-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 700;
}

.stat-row-record {
  font-size: 13px;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  color: var(--vb-text-muted);
}

.stat-row-pct {
  font-family: var(--vb-font-score);
  font-size: 18px;
  font-weight: 800;
  min-width: 2.2em;
  text-align: right;
}

.stat-row-bar {
  height: 4px;
  margin-top: 8px;
  border-radius: 999px;
  background: var(--vb-surface-2);
  overflow: hidden;
}

.stat-row-bar span {
  display: block;
  height: 100%;
  background: var(--vb-primary);
  border-radius: inherit;
}

.stat-row-meta {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: var(--vb-text-muted);
  font-weight: 600;
}

.loading,
.empty-state {
  text-align: center;
  padding: 40px 16px;
  color: var(--vb-text-muted);
  font-size: 14px;
}

.empty-state svg {
  margin-bottom: 8px;
  opacity: 0.4;
}

.empty-inline {
  margin: 12px 0;
  color: var(--vb-text-muted);
  font-size: 13px;
}

.error-message {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  padding: 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 650;
  text-align: center;
}

.retry-btn {
  display: inline-block;
  margin-top: 8px;
  background: var(--vb-primary);
  color: var(--vb-primary-contrast);
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  font-weight: 700;
  cursor: pointer;
}

.stats-game-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.stats-game-row {
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  border-left: 4px solid var(--vb-border);
  overflow: hidden;
}

.stats-game-row.win { border-left-color: var(--vb-success); }
.stats-game-row.loss { border-left-color: var(--vb-danger); }
.stats-game-row.tie { border-left-color: var(--vb-warning); }

.stats-game-main {
  display: block;
  width: 100%;
  text-align: left;
  background: none;
  border: none;
  color: inherit;
  padding: 10px 12px 8px;
  cursor: pointer;
}

.stats-game-main:hover { background: var(--vb-surface-hover); }

.stats-game-time {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.stats-game-teams {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 700;
}

.stats-game-teams span:last-child { text-align: right; }

.stats-game-score {
  font-family: var(--vb-font-score);
  font-size: 20px;
  font-weight: 800;
}

.stats-game-links {
  display: flex;
  gap: 6px;
  padding: 0 10px 10px;
}

.stats-game-links button {
  min-height: 28px;
  padding: 2px 8px;
  border: none;
  background: var(--vb-surface-2);
  color: var(--vb-text-muted);
  border-radius: 999px;
  font-size: 11px;
  font-weight: 650;
  cursor: pointer;
}

@media (min-width: 640px) {
  .statistics { padding: 8px 8px 40px; }
  .record-num strong { font-size: 2.8rem; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Statistics.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,6BAA6B;EAC7B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,gDAAgD,aAAa,EAAE;;AAE/D;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,uBAAuB,6BAA6B,EAAE;AACtD,wBAAwB,4BAA4B,EAAE;AACtD,uBAAuB,6BAA6B,EAAE;;AAEtD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY,6BAA6B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,YAAY,6BAA6B,EAAE,cAAc,EAAE;;AAE3D;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,yBAAyB,eAAe,EAAE;AAC1C,+BAA+B,mCAAmC,EAAE;;AAEpE;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA,sBAAsB,oCAAoC,EAAE;AAC5D,uBAAuB,mCAAmC,EAAE;AAC5D,sBAAsB,oCAAoC,EAAE;;AAE5D;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA,yBAAyB,mCAAmC,EAAE;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA,oCAAoC,iBAAiB,EAAE;;AAEvD;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc,qBAAqB,EAAE;EACrC,qBAAqB,iBAAiB,EAAE;AAC1C","sourcesContent":[".statistics {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 4px 4px 32px;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.stats-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.stats-toolbar-left {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  min-width: 0;\n}\n\n.statistics h1 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  text-align: left;\n  text-transform: none;\n}\n\n.stats-range {\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.range-chips {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.chip {\n  min-height: 32px;\n  padding: 4px 10px;\n  border: 1px solid var(--vb-border);\n  border-radius: 999px;\n  background: var(--vb-surface);\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.chip.active {\n  background: var(--vb-navy);\n  border-color: transparent;\n  color: #fff;\n}\n\nbody.night-mode .chip.active {\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n}\n\n.custom-range {\n  margin-bottom: 10px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  padding: 0 12px;\n}\n\n.custom-range summary {\n  cursor: pointer;\n  list-style: none;\n  padding: 8px 0;\n  font-size: 12px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.custom-range summary::-webkit-details-marker { display: none; }\n\n.custom-range-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  padding-bottom: 10px;\n}\n\n.custom-range-fields label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.custom-range-fields input {\n  min-height: 40px;\n  padding: 6px 8px;\n  border: 1px solid var(--vb-border);\n  border-radius: 8px;\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  font-size: 14px;\n}\n\n.stats-tabs {\n  display: flex;\n  gap: 0;\n  margin: 0 0 14px;\n  border-bottom: 1px solid var(--vb-border);\n}\n\n.stats-tabs button {\n  flex: 1;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 8px 6px 10px;\n  margin-bottom: -1px;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.stats-tabs button.active {\n  color: var(--vb-text);\n  border-bottom-color: var(--vb-primary);\n}\n\n.record-card,\n.form-strip,\n.metric-strip,\n.list-section {\n  margin-bottom: 12px;\n}\n\n.record-card {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 14px;\n  padding: 14px 14px 12px;\n}\n\n.record-line {\n  display: flex;\n  align-items: flex-end;\n  gap: 8px;\n}\n\n.record-num {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 2.2em;\n}\n\n.record-num strong {\n  font-family: var(--vb-font-score);\n  font-size: 2.4rem;\n  font-weight: 800;\n  line-height: 0.9;\n}\n\n.record-num span,\n.record-pct span {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: var(--vb-text-muted);\n}\n\n.record-sep {\n  color: var(--vb-text-muted);\n  font-weight: 700;\n  padding-bottom: 14px;\n}\n\n.record-pct {\n  margin-left: auto;\n  text-align: right;\n}\n\n.record-pct strong {\n  display: block;\n  font-family: var(--vb-font-score);\n  font-size: 1.8rem;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.record-bar {\n  display: flex;\n  height: 6px;\n  margin-top: 12px;\n  border-radius: 999px;\n  overflow: hidden;\n  background: var(--vb-surface-2);\n}\n\n.record-bar .seg.win { background: var(--vb-success); }\n.record-bar .seg.loss { background: var(--vb-danger); }\n.record-bar .seg.tie { background: var(--vb-warning); }\n\n.form-strip {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.form-label {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--vb-text-muted);\n  flex-shrink: 0;\n}\n\n.form-display {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.form-dot {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: grid;\n  place-items: center;\n  font-size: 11px;\n  font-weight: 800;\n  color: #fff;\n}\n\n.form-win { background: var(--vb-success); }\n.form-loss { background: var(--vb-danger); }\n.form-tie { background: var(--vb-warning); color: #0f172a; }\n\n.metric-strip {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.metric-strip div {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 10px 8px;\n  text-align: center;\n  min-width: 0;\n}\n\n.metric-strip strong {\n  display: block;\n  font-size: 15px;\n  font-weight: 800;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.metric-strip span {\n  font-size: 10px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.list-section h2 {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 800;\n  text-align: left;\n  text-transform: none;\n  color: var(--vb-text-muted);\n}\n\n.stats-search {\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 40px;\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 14px;\n}\n\n.rank-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.stat-row {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 10px 12px;\n  color: inherit;\n  cursor: default;\n}\n\n.stat-row.is-clickable { cursor: pointer; }\n.stat-row.is-clickable:hover { background: var(--vb-surface-hover); }\n\n.stat-row-top {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  align-items: center;\n  gap: 8px;\n}\n\n.stat-row-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.stat-row-record {\n  font-size: 13px;\n  font-weight: 650;\n  font-variant-numeric: tabular-nums;\n  color: var(--vb-text-muted);\n}\n\n.stat-row-pct {\n  font-family: var(--vb-font-score);\n  font-size: 18px;\n  font-weight: 800;\n  min-width: 2.2em;\n  text-align: right;\n}\n\n.stat-row-bar {\n  height: 4px;\n  margin-top: 8px;\n  border-radius: 999px;\n  background: var(--vb-surface-2);\n  overflow: hidden;\n}\n\n.stat-row-bar span {\n  display: block;\n  height: 100%;\n  background: var(--vb-primary);\n  border-radius: inherit;\n}\n\n.stat-row-meta {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.loading,\n.empty-state {\n  text-align: center;\n  padding: 40px 16px;\n  color: var(--vb-text-muted);\n  font-size: 14px;\n}\n\n.empty-state svg {\n  margin-bottom: 8px;\n  opacity: 0.4;\n}\n\n.empty-inline {\n  margin: 12px 0;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n}\n\n.error-message {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  padding: 12px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 650;\n  text-align: center;\n}\n\n.retry-btn {\n  display: inline-block;\n  margin-top: 8px;\n  background: var(--vb-primary);\n  color: var(--vb-primary-contrast);\n  border: none;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.stats-game-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.stats-game-row {\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  border-left: 4px solid var(--vb-border);\n  overflow: hidden;\n}\n\n.stats-game-row.win { border-left-color: var(--vb-success); }\n.stats-game-row.loss { border-left-color: var(--vb-danger); }\n.stats-game-row.tie { border-left-color: var(--vb-warning); }\n\n.stats-game-main {\n  display: block;\n  width: 100%;\n  text-align: left;\n  background: none;\n  border: none;\n  color: inherit;\n  padding: 10px 12px 8px;\n  cursor: pointer;\n}\n\n.stats-game-main:hover { background: var(--vb-surface-hover); }\n\n.stats-game-time {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.stats-game-teams {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 8px;\n  align-items: center;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.stats-game-teams span:last-child { text-align: right; }\n\n.stats-game-score {\n  font-family: var(--vb-font-score);\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.stats-game-links {\n  display: flex;\n  gap: 6px;\n  padding: 0 10px 10px;\n}\n\n.stats-game-links button {\n  min-height: 28px;\n  padding: 2px 8px;\n  border: none;\n  background: var(--vb-surface-2);\n  color: var(--vb-text-muted);\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n@media (min-width: 640px) {\n  .statistics { padding: 8px 8px 40px; }\n  .record-num strong { font-size: 2.8rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
